import { FunctionalComponent, createContext, h } from 'preact';
import { TabId, UseTabsReturn } from './interface';
import { useContext, useEffect, useState } from 'preact/hooks';
import { useUiContext } from '../../contexts/UiContext';

const initialValue: UseTabsReturn = {
  registerPanel: () => null,
  select: () => null,
  selected: null,
  unRegisterPanel: () => null,
};

const TabsContext = createContext<UseTabsReturn>(initialValue);

export const Tabs: FunctionalComponent = ({ children }) => {
  const { tabView, setTabView } = useUiContext();
  const [selected, setSelectedTab] = useState<TabId | null>(tabView);
  const [panels, setPanels] = useState<TabId[]>([]);

  useEffect(() => {
    if (!selected || selected !== tabView) {
      setSelectedTab(tabView);
    }
  }, [selected, tabView]);

  const select = (tabId: TabId) => {
    setSelectedTab(tabId);
    setTabView(tabId);
  };

  const registerPanel = (panel: TabId): void => {
    setPanels([...panels, panel]);
  };

  const unRegisterPanel = (panel: TabId): void => {
    setPanels(panels.filter((item) => item !== panel));
  };

  return (
    <TabsContext.Provider value={{ registerPanel, select, selected, unRegisterPanel }}>{children}</TabsContext.Provider>
  );
};

export const useTabs = (): UseTabsReturn => {
  return useContext(TabsContext);
};
